import { useAppSelector } from 'hooks';
import { useFeatureFlag } from 'hooks/useFeatureFlag';

import {
  BARA_REFERRAL_STATUS_APPROVED,
  WIP_STATUS_APPEAL_APPROVED,
  WIP_STATUS_BARA_APPROVED,
} from 'variables/constants';

export const useHasUnderwritingApproval = (
  formStateKey: 'autoPersonalForm' | 'homePersonalForm',
): boolean => {
  const isBaraEnabled = useFeatureFlag('enable-bara');
  const appeal = useAppSelector((state) => state[formStateKey].appeal);
  const baraReferral = useAppSelector(
    (state) => state[formStateKey].bara_referral,
  );
  const wipStatus = useAppSelector((state) => state[formStateKey].wip_status);
  const isBaraFixesEnabled = useFeatureFlag('enable-bara-referral-fixes');

  const hasApprovedBaraReferral =
    isBaraEnabled &&
    ((!!baraReferral &&
      baraReferral.status === BARA_REFERRAL_STATUS_APPROVED) ||
      (isBaraFixesEnabled && wipStatus === WIP_STATUS_BARA_APPROVED));
  const hasApprovedPUAppeal =
    !!appeal && appeal.status === WIP_STATUS_APPEAL_APPROVED;

  return hasApprovedBaraReferral || hasApprovedPUAppeal;
};
